import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import './SelectInputWithSymbol.scss';
function SelectInputWithSymbol(_ref) {
  var label = _ref.label,
    symbol = _ref.symbol,
    symbolPosition = _ref.symbolPosition,
    inputName = _ref.inputName,
    value = _ref.value,
    _onChange = _ref.onChange,
    options = _ref.options,
    containerWidth = _ref.containerWidth,
    containerClasss = _ref.containerClasss,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "select-with-symbol",
    style: {
      width: containerWidth
    }
  }, label, /*#__PURE__*/React.createElement("div", {
    className: "select-container ".concat(containerClasss)
  }, symbolPosition === 'left' && /*#__PURE__*/React.createElement("span", {
    className: "symbol"
  }, typeof symbol === 'string' ? symbol : symbol), /*#__PURE__*/React.createElement(Select, {
    id: inputName,
    className: "basic-single",
    classNamePrefix: "select",
    name: inputName,
    value: value,
    onChange: function onChange(event) {
      return _onChange(event);
    },
    options: options
  }), symbolPosition === 'right' && /*#__PURE__*/React.createElement("span", {
    className: "symbol"
  }, typeof symbol === 'string' ? symbol : symbol)), children && /*#__PURE__*/React.createElement("div", {
    className: "extra-content"
  }, children));
}
SelectInputWithSymbol.propTypes = {
  label: PropTypes.string,
  symbol: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  symbolPosition: PropTypes.oneOf(['left', 'right']),
  inputName: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string.isRequired
  })),
  // Options for select input
  containerWidth: PropTypes.string,
  children: PropTypes.node,
  // For nested content
  errors: PropTypes.shape({})
};
SelectInputWithSymbol.defaultProps = {
  label: null,
  symbol: '$',
  symbolPosition: null,
  errors: {},
  containerWidth: '100%',
  options: [],
  children: null
};
export default SelectInputWithSymbol;